import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataObjectDescriptionVersionUrl } from './DataObjectDescriptionVersionUrl';
import { VersionDataSchema } from '../schema';

export const getDataObjectDescriptionVersions = ({
  id,
  valueDate,
}: {
  id: string | number;
  valueDate?: string;
}) =>
  apiClient
    .get(
      expand(DataObjectDescriptionVersionUrl.byDataObject, { id, valueDate }),
    )
    .then((response) => VersionDataSchema.array().parse(response.data));

export const useGetDataObjectDescriptionVersions = createApiQueryHook(
  ['data-object-description-versions'],
  getDataObjectDescriptionVersions,
);
